import React from 'react';
import { SetMenu } from '../../types/set-menu';
import {
    Box,
    Card,
    CardContent,
    Chip,
    Divider,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@mui/material';

interface SetMenuPreviewProps {
    setMenu: SetMenu;
}

const SetMenuPreview = ({ setMenu }: SetMenuPreviewProps) => {
    return (
        <Card variant='outlined' sx={{ mt: 2 }}>
            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: 1,
                    }}
                >
                    <Box>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            {setMenu.name}
                        </Typography>
                        <Chip
                            size='small'
                            label={setMenu.serviceType}
                            sx={{ textTransform: 'capitalize', mt: 0.5 }}
                        />
                    </Box>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        ${Number(setMenu.pricePerPerson).toFixed(2)} pp
                    </Typography>
                </Box>
                {setMenu.description && (
                    <Typography
                        variant='body3'
                        sx={{
                            color: 'text.secondary',
                            display: 'block',
                            mt: 1,
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {setMenu.description}
                    </Typography>
                )}
                <Divider sx={{ my: 1 }} />
                <List dense>
                    {setMenu.items.map((item, index) => (
                        <ListItem divider key={item.id ?? index}>
                            <ListItemText
                                primary={item.name}
                                secondary={item.description}
                                secondaryTypographyProps={{
                                    whiteSpace: 'pre-wrap',
                                }}
                            />
                            <Chip
                                size='small'
                                variant='outlined'
                                label={item.course}
                                sx={{ textTransform: 'capitalize' }}
                            />
                        </ListItem>
                    ))}
                </List>
                <Divider sx={{ my: 1 }} />
                <Box>
                    <Typography
                        variant='subtitle2'
                        sx={{ fontWeight: 600, mb: 1 }}
                    >
                        Available on
                    </Typography>
                    {setMenu.modules && setMenu.modules.length > 0 ? (
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 0.5,
                            }}
                        >
                            {setMenu.modules.map((module) => (
                                <Chip
                                    key={module.id}
                                    size='small'
                                    variant='outlined'
                                    label={module.name ?? `Venue #${module.id}`}
                                />
                            ))}
                        </Box>
                    ) : (
                        <Typography
                            variant='body3'
                            sx={{ color: 'text.secondary' }}
                        >
                            No experiences selected for this set menu
                        </Typography>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default SetMenuPreview;
